import config from './GooglePublisherTags.config';

let googletag = null;

function defineNamespace() {
  googletag = window.googletag || {};
  googletag.cmd = googletag.cmd || [];
  window.googletag = googletag;
}

function loadScript() {
  const script = document.createElement('script');
  script.async = true;
  script.type = 'text/javascript';
  script.src = '//www.googletagservices.com/tag/js/gpt.js';
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(script);
}

function defineSlots() {
  config.placements.forEach((data) => {
    const element = document.getElementById(data.id);
    if (element) {
      googletag.cmd.push(() => {
        googletag.defineSlot(`/${config.account}/${data.name}`, data.sizes, data.id).addService(googletag.pubads());
      });
    }
  });
}

function enableServices() {
  googletag.cmd.push(() => {
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
  });
}

function displaySlots() {
  config.placements.forEach((data) => {
    const element = document.getElementById(data.id);
    if (element) {
      googletag.cmd.push(() => {
        googletag.display(data.id);
      });
    }
  });
}

export default class GooglePublisherTags {
  constructor() {
    if (!config) throw Error('No configuration found');
    defineNamespace();
    defineSlots();
    enableServices();
    displaySlots();
    loadScript();
  }
}
